import React, { useEffect, useState } from "react";
import Loader from "../../components/Loader";

import axios from "axios";
import { useParams } from "react-router-dom";
import AdminNav from "./AdminNav";
import Sidebar from "./Sidebar";
import { FaBarsStaggered } from "react-icons/fa6";
const Bank = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [bankData, setBankData] = useState();
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  const token = localStorage.getItem("admintoken");

  useEffect(() => {
    const fetchBankData = async () => {
      setLoading(true);
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API}/api/v1/bank/get-bank-data/${id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (data?.success) {
          setBankData(data.bank);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    fetchBankData();
  }, [id, token]);

  return (
    <>
      {loading && <Loader />}
      <div className="wrapper d-flex align-items-stretch">
        <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
        <div id="content" className="px-2">
          <button
            type="button"
            id="openSidebar"
            onClick={toggleSidebar}
            className="bars-btn"
          >
            <FaBarsStaggered />
          </button>
          <AdminNav />
          <div className="user-profile-main">
            <div className="user-details-card">
              <h4 className="  pb-3">Bank Details</h4>
              <div className="user-personal-main">
                <div className="">
                  <div className="user-personal-main-left">
                    <div className="">
                      <h6 className="user-profil-text">Bank Name</h6>
                      <h4 className="user-profile-sm-text">
                        {bankData?.bankName}
                      </h4>
                    </div>
                    <div className="">
                      <h6 className="user-profil-text">Account No</h6>
                      <h4 className="user-profile-sm-text">
                        {bankData?.accountNumber}
                      </h4>
                    </div>
                    <div className="">
                      <h6 className="user-profil-text">Sort Code</h6>
                      <h4 className="user-profile-sm-text">
                        {bankData?.sortCode}
                      </h4>
                    </div>
                  </div>

                  <div className="user-personal-main-left">
                    <div className="">
                      <h6 className="user-profil-text">Bank Address</h6>
                      <h4 className="user-profile-sm-text">
                        {bankData?.bankAddress}
                      </h4>
                    </div>
                    <div className="">
                      <h6 className="user-profil-text">IBAN No</h6>
                      <h4 className="user-profile-sm-text">{bankData?.iban}</h4>
                    </div>
                    <div className="">
                      <h6 className="user-profil-text">SWIFT/BIC Code</h6>
                      <h4 className="user-profile-sm-text">
                        {bankData?.swiftCode}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Bank;
